/** Default color values for the booking-hotel-manage theme editor. */
export const DEFAULT_MANAGE_THEME: any = {
  // GLOBAL
  background: '#f5f6f8',
  textColor: '#2d3436',

  // CARD / PANEL
  cardBackground: '#ffffff',
  cardBorder: '#e5e7eb',
  cardShadow: 'rgba(15, 23, 42, 0.05)',

  // TITLES
  pageTitle: '#23344e',
  sectionTitle: '#0f172a',
  sectionDescription: '#64748b',

  // FORM
  labelColor: '#334155',
  inputBackground: '#ffffff',
  inputBorder: '#d1d5db',
  inputText: '#334155',

  // BUTTONS
  primaryButtonBackground: '#2563eb',
  primaryButtonText: '#ffffff',

  outlineButtonBackground: '#ffffff',
  outlineButtonBorder: '#cccccc',
  outlineButtonText: '#334155',

  warningButtonBackground: '#ffebee',
  warningButtonBorder: '#ffcdd2',
  warningButtonText: '#c62828',

  // TABLE
  tableHeaderBackground: '#f8fafc',
  tableHeaderText: '#475569',
  tableHeaderBorder: '#e2e8f0',

  tableCellText: '#334155',
  tableCellBorder: '#eef2f7',

  // ALERTS
  successAlertBackground: '#33a564',
  successAlertText: '#ffffff',

  infoMessageBackground: '#e7f0fa',
  infoMessageText: '#000000',

  // DETAIL / INFO
  detailBoxBackground: '#ffffff',
  detailBoxBorder: '#dddddd',

  infoLabel: '#1f2f46',
  infoValue: '#333333',

  // ROOM
  roomTitle: '#23344e',
  roomLabel: '#444444',
  roomValue: '#222222',
  extraServiceValue: '#0b67ff',

  cancelTagBackground: '#e78d96',
  cancelTagText: '#ffffff',

  // PAYMENT
  paymentLabel: '#1f2f46',
  paymentValue: '#333333',

  paymentStatusBorder: '#cccccc',
  paymentStatusText: '#333333',

  // LOCATION
  locationLabel: '#111827',
  locationValue: '#333333',

  // SUMMARY
  summaryLabel: '#1f2f46',
  summaryValue: '#0f172a',

  // POLICY
  policyText: '#333333',
};

/** Flat label lookup for every theme key (used by the "view all" expanded panel) */
export const MANAGE_COLOR_OPTIONS: any[] = [
  { key: 'textColor', label: 'mau_chu_tong' },
  { key: 'cardBackground', label: 'nen_the' },
  { key: 'cardBorder', label: 'vien_the' },
  { key: 'pageTitle', label: 'tieu_de_trang' },
  { key: 'sectionTitle', label: 'tieu_de_muc' },
  { key: 'sectionDescription', label: 'mo_ta_muc' },
  { key: 'labelColor', label: 'mau_nhan_form' },
  { key: 'inputBackground', label: 'nen_o_nhap' },
  { key: 'inputBorder', label: 'vien_o_nhap' },
  { key: 'inputText', label: 'chu_o_nhap' },
  { key: 'primaryButtonBackground', label: 'nen_nut_chinh' },
  { key: 'primaryButtonText', label: 'chu_nut_chinh' },
  { key: 'outlineButtonBackground', label: 'nen_nut_vien' },
  { key: 'outlineButtonBorder', label: 'vien_nut_vien' },
  { key: 'outlineButtonText', label: 'chu_nut_vien' },
  { key: 'warningButtonBackground', label: 'nen_nut_canh_bao' },
  { key: 'warningButtonBorder', label: 'vien_nut_canh_bao' },
  { key: 'warningButtonText', label: 'chu_nut_canh_bao' },
  { key: 'tableHeaderBackground', label: 'nen_tieu_de_bang' },
  { key: 'tableHeaderText', label: 'chu_tieu_de_bang' },
  { key: 'tableHeaderBorder', label: 'vien_tieu_de_bang' },
  { key: 'tableCellText', label: 'chu_o_bang' },
  { key: 'tableCellBorder', label: 'vien_o_bang' },
  { key: 'successAlertBackground', label: 'nen_thong_bao_thanh_cong' },
  { key: 'successAlertText', label: 'chu_thong_bao_thanh_cong' },
  { key: 'infoMessageBackground', label: 'nen_thong_tin' },
  { key: 'infoMessageText', label: 'chu_thong_tin' },
  { key: 'detailBoxBackground', label: 'nen_hop_chi_tiet' },
  { key: 'detailBoxBorder', label: 'vien_hop_chi_tiet' },
  { key: 'infoLabel', label: 'nhan_thong_tin' },
  { key: 'infoValue', label: 'gia_tri_thong_tin' },
  { key: 'roomTitle', label: 'tieu_de_phong' },
  { key: 'roomLabel', label: 'label_phong' },
  { key: 'roomValue', label: 'gia_tri_phong' },
  { key: 'extraServiceValue', label: 'gia_tri_dich_vu_bo_sung' },
  { key: 'cancelTagBackground', label: 'nen_nhan_huy' },
  { key: 'cancelTagText', label: 'chu_nhan_huy' },
  { key: 'paymentLabel', label: 'nhan_thanh_toan' },
  { key: 'paymentValue', label: 'gia_tri_thanh_toan' },
  { key: 'paymentStatusBorder', label: 'vien_trang_thai_thanh_toan' },
  { key: 'paymentStatusText', label: 'chu_trang_thai_thanh_toan' },
  { key: 'locationLabel', label: 'nhan_vi_tri' },
  { key: 'locationValue', label: 'gia_tri_vi_tri' },
  { key: 'summaryLabel', label: 'nhan_tom_tat' },
  { key: 'summaryValue', label: 'gia_tri_tom_tat' },
  { key: 'policyText', label: 'chu_chinh_sach' },
];

/**
 * Maps each theme key to the CSS property + style-class keys (in `this.class`)
 * that `updateManageGroupColor()` writes the value into.
 */
export const MANAGE_COLOR_GROUPS: any = {
  background: { property: 'background-color', classes: ['booking-hotel-manage'] },
  textColor: { property: 'color', classes: ['booking-hotel-manage'] },

  cardBackground: { property: 'background', classes: ['section-card', 'detail-box', 'refund-detail-card'] },
  cardBorder: { property: 'border-color', classes: ['section-card', 'detail-box'] },

  pageTitle: { property: 'color', classes: ['page-title'] },
  sectionTitle: { property: 'color', classes: ['section-title', 'detail-heading', 'room-type-title'] },
  sectionDescription: { property: 'color', classes: ['section-description'] },

  labelColor: { property: 'color', classes: ['form-label', 'location-label'] },

  primaryButtonBackground: { property: 'background', classes: ['save-btn'] },
  primaryButtonText: { property: 'color', classes: ['save-btn'] },

  outlineButtonBackground: { property: 'background', classes: ['outline-btn'] },
  outlineButtonBorder: { property: 'border-color', classes: ['outline-btn'] },
  outlineButtonText: { property: 'color', classes: ['outline-btn'] },

  warningButtonBackground: { property: 'background', classes: ['warning-btn'] },
  warningButtonBorder: { property: 'border-color', classes: ['warning-btn'] },
  warningButtonText: { property: 'color', classes: ['warning-btn'] },

  tableHeaderBackground: { property: 'background', classes: ['table-header'] },
  tableHeaderText: { property: 'color', classes: ['table-header'] },
  tableHeaderBorder: { property: 'border-bottom-color', classes: ['table-header'] },

  tableCellText: { property: 'color', classes: ['table-cell'] },
  tableCellBorder: { property: 'border-bottom-color', classes: ['table-cell'] },

  successAlertBackground: { property: 'background', classes: ['booking-alert'] },
  successAlertText: { property: 'color', classes: ['booking-alert'] },

  infoMessageBackground: { property: 'background', classes: ['info-message'] },
  infoMessageText: { property: 'color', classes: ['info-message'] },

  detailBoxBackground: { property: 'background', classes: ['detail-box'] },
  detailBoxBorder: { property: 'border-color', classes: ['detail-box'] },

  infoLabel: { property: 'color', classes: ['info-label', 'payment-label', 'summary-label'] },
  infoValue: { property: 'color', classes: ['info-value', 'payment-value', 'location-value'] },

  roomTitle: { property: 'color', classes: ['room-type-title'] },
  roomLabel: { property: 'color', classes: ['room-label'] },
  roomValue: { property: 'color', classes: ['room-value'] },
  extraServiceValue: { property: 'color', classes: ['extra-services-value'] },

  paymentLabel: { property: 'color', classes: ['payment-label'] },
  paymentValue: { property: 'color', classes: ['payment-value'] },

  paymentStatusBorder: { property: 'border-color', classes: ['payment-status'] },
  paymentStatusText: { property: 'color', classes: ['payment-status'] },

  locationLabel: { property: 'color', classes: ['location-label'] },
  locationValue: { property: 'color', classes: ['location-value'] },

  summaryLabel: { property: 'color', classes: ['summary-label'] },
  summaryValue: { property: 'color', classes: ['summary-value'] },

  policyText: { property: 'color', classes: ['policy-text'] },

  // Note: cardShadow, cancelTagBackground, cancelTagText exist in
  // DEFAULT_MANAGE_THEME but have no group mapping here — same as the
  // original file. updateManageGroupColor() no-ops for keys with no
  // matching group, so applyManageTheme() silently skips them.
};

/** Groups color keys under a collapsible UI section, in display order. */
export const MANAGE_COLOR_SECTIONS: any[] = [
  {
    title: 'chung',
    fields: [
      { key: 'textColor', label: 'mau_chu_tong' },
      { key: 'cardBackground', label: 'nen_the' },
      { key: 'cardBorder', label: 'vien_the' },
    ],
  },
  {
    title: 'tieu_de',
    fields: [
      { key: 'pageTitle', label: 'tieu_de_trang' },
      { key: 'sectionTitle', label: 'tieu_de_muc' },
      { key: 'sectionDescription', label: 'mo_ta_muc' },
    ],
  },
  {
    title: 'Form',
    fields: [
      { key: 'labelColor', label: 'mau_nhan_form' },
      { key: 'inputBackground', label: 'nen_o_nhap' },
      { key: 'inputBorder', label: 'vien_o_nhap' },
      { key: 'inputText', label: 'chu_o_nhap' },
    ],
  },
  {
    title: 'nut_bam',
    fields: [
      { key: 'primaryButtonBackground', label: 'nen_nut_chinh' },
      { key: 'primaryButtonText', label: 'chu_nut_chinh' },
      { key: 'outlineButtonBackground', label: 'nen_nut_vien' },
      { key: 'outlineButtonBorder', label: 'vien_nut_vien' },
      { key: 'outlineButtonText', label: 'chu_nut_vien' },
      { key: 'warningButtonBackground', label: 'nen_nut_canh_bao' },
      { key: 'warningButtonBorder', label: 'vien_nut_canh_bao' },
      { key: 'warningButtonText', label: 'chu_nut_canh_bao' },
    ],
  },
  {
    title: 'cot_bang',
    fields: [
      { key: 'tableHeaderBackground', label: 'nen_tieu_de_bang' },
      { key: 'tableHeaderText', label: 'chu_tieu_de_bang' },
      { key: 'tableHeaderBorder', label: 'vien_tieu_de_bang' },
      { key: 'tableCellText', label: 'chu_o_bang' },
      { key: 'tableCellBorder', label: 'vien_o_bang' },
    ],
  },
  {
    title: 'thong_bao',
    fields: [
      { key: 'successAlertBackground', label: 'nen_thong_bao_thanh_cong' },
      { key: 'successAlertText', label: 'chu_thong_bao_thanh_cong' },
      { key: 'infoMessageBackground', label: 'nen_thong_tin' },
      { key: 'infoMessageText', label: 'chu_thong_tin' },
    ],
  },
  {
    title: 'chi_tiet',
    fields: [
      { key: 'detailBoxBackground', label: 'nen_hop_chi_tiet' },
      { key: 'detailBoxBorder', label: 'vien_hop_chi_tiet' },
      { key: 'infoLabel', label: 'nhan_thong_tin' },
      { key: 'infoValue', label: 'gia_tri_thong_tin' },
    ],
  },
  {
    title: 'phong',
    fields: [
      { key: 'roomTitle', label: 'tieu_de_phong' },
      { key: 'roomLabel', label: 'nhan_phong' },
      { key: 'roomValue', label: 'gia_tri_phong' },
      { key: 'extraServiceValue', label: 'gia_tri_dich_vu_bo_sung' },
    ],
  },
  {
    title: 'thanh_toan',
    fields: [
      { key: 'paymentLabel', label: 'nhan_thanh_toan' },
      { key: 'paymentValue', label: 'gia_tri_thanh_toan' },
      { key: 'paymentStatusBorder', label: 'vien_trang_thai_thanh_toan' },
      { key: 'paymentStatusText', label: 'chu_trang_thai_thanh_toan' },
    ],
  },
  {
    title: 'vi_tri',
    fields: [
      { key: 'locationLabel', label: 'nhan_vi_tri' },
      { key: 'locationValue', label: 'gia_tri_vi_tri' },
    ],
  },
  {
    title: 'tom_tat',
    fields: [
      { key: 'summaryLabel', label: 'nhan_tom_tat' },
      { key: 'summaryValue', label: 'gia_tri_tom_tat' },
    ],
  },
  {
    title: 'chinh_sach',
    fields: [{ key: 'policyText', label: 'chu_chinh_sach' }],
  },
];